import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {
   readonly httpServicesUrl: string = 'https://okshan.com/okshan-admin/api/';
   readonly uploadFileUrl: string = 'https://okshan.com/okshan-admin/';
   readonly webUrl: string = 'https://okshan.com/okshan/#/';

   

    //readonly httpServicesUrl: string = 'https://okshan.in/TEST/okshan-api/api/';
    //readonly uploadFileUrl: string = 'https://okshan.in/TEST/okshan-api/';
    //readonly webUrl: string = 'https://okshan.in/TEST/auction/#/';



   //readonly httpServicesUrl: string = 'https://test.meshink.xyz/okshan-admin/api/';
   //readonly uploadFileUrl: string = 'https://test.meshink.xyz/okshan-admin/';
   //readonly webUrl: string = 'https://test.meshink.xyz/okshan/#/';
   
   // readonly httpServicesUrl: string = 'http://13.235.56.111/TEST/okshan-api/api/';
   // readonly uploadFileUrl: string = 'http://13.235.56.111/TEST/okshan-api/';
   // readonly webUrl: string = 'http://13.235.56.111/TEST/auction/#/';

   //readonly httpServicesUrl: string = 'http://13.235.56.111/QA/okshan-api/api/';
   //readonly uploadFileUrl: string = 'http://13.235.56.111/QA/okshan-api/';
   //readonly webUrl: string = 'http://13.235.56.111/QA/auction/#/';

   //readonly httpServicesUrl: string = 'http://127.0.0.1:8000/api/';
   //readonly uploadFileUrl: string = 'http://127.0.0.1:8000/';
   //readonly webUrl: string = 'http://127.0.0.1:8000/#/';
   //readonly  uploadFileUrlForAWS = 'https://okshan-images.s3.ap-south-1.amazonaws.com/';
   readonly  uploadFileUrlForAWS = '';

  constructor() { }
}
